<template>
  <li>
    <button
      v-if="collapsible"
      type="button"
      class="menu-label is-collapsible"
      :aria-expanded="String(open)"
      :aria-controls="listId"
      :aria-label="headerLabel"
      @click="$emit('toggle')"
    >
      <b class="menu-label__title">{{ title }}</b>
      <span
        v-if="current && !open"
        class="menu-label__current"
        aria-hidden="true"
      />
      <small
        class="menu-label__count"
        aria-hidden="true"
      >{{ routes.length }}</small>
      <i
        class="fas"
        :class="open ? 'fa-chevron-up' : 'fa-chevron-down'"
        aria-hidden="true"
      />
    </button>
    <span
      v-else
      class="menu-label is-bolder"
    >
      {{ title }}
    </span>
    <ul
      v-show="!collapsible || open"
      :id="listId"
    >
      <NavigationItem
        v-for="(route, j) in routes"
        :key="`item-${j}`"
        :route="route"
      />
    </ul>
  </li>
</template>

<script>
import NavigationItem from '@/components/Navigation/NavigationItem.vue';

export default {
  name: 'NavigationSection',
  components: {
    NavigationItem,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    routes: {
      type: Array,
      required: true,
    },
    collapsible: {
      type: Boolean,
      default: false,
    },
    open: {
      type: Boolean,
      default: false,
    },
    current: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    headerLabel() {
      const total = this.routes.length;

      const label = `${this.title}, ${total} ${total === 1 ? 'item' : 'itens'}`;

      return this.current && !this.open ? `${label}, tela atual` : label;
    },
    listId() {
      return `navigation-section-${this.title.normalize('NFD').replace(/[^\w]+/g, '-').toLowerCase()}`;
    },
  },
};
</script>
